// @ts-nocheck
import AForm from './ant-form';
import { configure, addInputType } from './ant-form';
export { AntForm } from './ant-form';
export type { AntFormProps } from './ant-form';
export type { AntSchema } from './types';
export { useAntForm } from './hooks/useAntForm';

const AntForm = AForm;
AntForm.configure = configure;
AntForm.addField = addInputType;

export default AntForm;
